module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-beach.17fee420.jpg";